import React from "react";
import { SrtMasterContainer } from "./styles";
import { useApp } from "../providers";
import { SrtRow } from "./styles";
import { SrtLogoColumn, SrtIconColumn, SrtTextColumn, SrtButtonColumn, SrtCloseTrayButton, SrtLogoWrapper } from "./styles";

// @ts-ignore
import DelphiniLogo from "@assets/srt-icons/delphini-logo.svg";
// @ts-ignore
import CloseTray from "@assets/srt-icons/close-tray.svg";

export const CommsCenterHeader = () => {
  const { darkMode } = useApp();
  return (
    <SrtMasterContainer>
      <SrtRow darkMode={darkMode}>
        <SrtLogoColumn>
          <SrtLogoWrapper darkMode={darkMode}>
            <DelphiniLogo />
          </SrtLogoWrapper>
        </SrtLogoColumn>
        <SrtTextColumn>Comms Center</SrtTextColumn>
        {/* <SrtButtonColumn>
          <SrtStrokedIconButton>
            <SlideRightIcon />
            Display Options
          </SrtStrokedIconButton>
        </SrtButtonColumn> */}
        {/* <SrtIconColumn>
          <SrtCloseTrayButton darkMode={darkMode}>
            <CloseTray />
          </SrtCloseTrayButton>
        </SrtIconColumn> */}
      </SrtRow>
    </SrtMasterContainer>
  );
};
